/* eslint-disable import/prefer-default-export */

import { getCookies } from '../api/api';
import i18n from '../i18n';
import { LanguageConstants } from './LanguageConstants';
import routerLoader from '../i18n/router';
import { StorageHelper } from './StorageHelper';
import { CookieHelper } from './CookieHelper';

export class LanguageHelper {
  static getCorrectedLocale = (
    localeInpunt: string,
    userParams: any,
    isGibraltar: any,
  ) => {
    let locale: string;
    if (
      localeInpunt === LanguageConstants.ID_INGLES ||
      localeInpunt === LanguageConstants.LOCALE_INGLES
    ) {
      locale = LanguageConstants.LOCALE_INGLES;
    } else if (
      localeInpunt === LanguageConstants.ID_ESPANIOL ||
      localeInpunt === LanguageConstants.LOCALE_ESPANIOL
    ) {
      locale = LanguageConstants.LOCALE_ESPANIOL;
    } else if (
      localeInpunt === LanguageConstants.ID_EUSKERA ||
      localeInpunt === LanguageConstants.LOCALE_EUSKERA
    ) {
      locale = LanguageConstants.LOCALE_EUSKERA;
    } else if (
      localeInpunt === LanguageConstants.ID_GALLEGO ||
      localeInpunt === LanguageConstants.LOCALE_GALLEGO
    ) {
      locale = LanguageConstants.LOCALE_GALLEGO;
    } else if (
      localeInpunt === LanguageConstants.ID_ALEMAN ||
      localeInpunt === LanguageConstants.LOCALE_ALEMAN
    ) {
      locale = LanguageConstants.LOCALE_ALEMAN;
    } else if (
      localeInpunt === LanguageConstants.ID_CATALAN ||
      localeInpunt === LanguageConstants.LOCALE_CATALAN
    ) {
      locale = LanguageConstants.LOCALE_CATALAN;
    } else {
      locale = LanguageConstants.LOCALE_ESPANIOL;
    }
    locale =
      userParams && userParams.currentLocale
        ? userParams.currentLocale
        : locale;
    const localeCookie = getCookies().get('i18next') as string;
    if (localeCookie) {
      if (isGibraltar) {
        if (localeCookie === LanguageConstants.LOCALE_ALEMAN) {
          locale = LanguageConstants.LOCALE_ESPANIOL;
        } else {
          locale = localeCookie;
        }
      } else if (
        localeCookie === LanguageConstants.LOCALE_ALEMAN ||
        localeCookie === LanguageConstants.LOCALE_INGLES
      ) {
        locale = LanguageConstants.LOCALE_ESPANIOL;
      } else {
        locale = localeCookie;
      }
    }
    LanguageHelper.setLanguage(locale);

    return locale;
  };

  static redirectIfUrlRemainsIncorrectLanguage = () => {
    const newUrl = window.location.pathname.split('/');
    const path = newUrl[2];
    const language = newUrl[1];
    if (language === LanguageConstants.LOCALE_ALEMAN) {
      const newPath = routerLoader.LoadRouterByPath(
        path,
        LanguageConstants.LOCALE_ESPANIOL,
      );
      window.history.replaceState(null, '', newPath);
    } else if (
      language === LanguageConstants.LOCALE_INGLES &&
      !StorageHelper.isGibraltar()
    ) {
      const newPath = routerLoader.LoadRouterByPath(
        path,
        LanguageConstants.LOCALE_ESPANIOL,
      );
      window.history.replaceState(null, '', newPath);
    }
    LanguageHelper.setLanguage(language);
  };

  static setLanguage = (locale: string) => {
    CookieHelper.setCookieValue('i18next', locale, { extricto: false });
    CookieHelper.setCookieValue('i18n', locale, { extricto: false });
    i18n.changeLanguage(locale);
  };
}
